export namespace FilterValueConstants {
  export const ServerPortAny = 'any';
  export const ServerPortDefault = 'default';
}